import * as R from 'ramda';

export default function SyncRiskConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  riskDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmSync = _handleConfirmSync;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmSync($event) {
    loaderService.showViewLoader = true;
    const riskIds = [];
    const syncDTO = {
      syncAllCustomerRisks: false,
      syncAllCustomerRisksForRiskType: false,
      customerRiskIds: riskIds,
    };
    if (!vm.isMultipleRisks) {
      riskIds.push(vm.risk.customerRiskId);
      syncDTO.customerId = vm.risk.customerId;
      syncDTO.customerRiskIds = riskIds;
      syncDTO.customerRiskTypeId = vm.risk.customerRiskTypeId;
    } else {
      syncDTO.customerId = vm.riskType.customerId;
      syncDTO.customerRiskTypeId = vm.riskType.customerRiskTypeId;
      R.forEach(
        (item) => {
          riskIds.push(item.customerRiskId);
        },
        vm.risks
      );
      syncDTO.customerRiskIds = riskIds;
    }
    return riskDataService.syncRisk(syncDTO)
      .then(() => {
        if (!vm.isMultipleRisks) {
          alerts.success(`The risk "${vm.risk.name}" was successfully synced.`);
        } else {
          alerts.success('The risks were successfully synced.');
        }
        if (vm.updateCallBack) {
          vm.updateCallBack();
        }
        _closeDialog($event);
      }).catch(() => {
        alerts.error('An error occurred while syncing the risk.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.riskAdmin.syncRiskDialog);
  }
}

SyncRiskConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'riskDataService',
  'loaderService',
  'ssDialogService'
];
